import React, { Component } from 'react';
import { connect } from 'react-redux';

import { DATASOURCE, HAULERS_PATH } from '../../../constants/apiConstants';
import { ADMIN_KEYS, ADMIN_LABELS } from '../../../constants/appConstants';
import { HAULERS_TEXT } from '../../../constants/navConstants';
import { addDataTest, addHeaderDataTest, getAddress } from '../../../util/adminUtil';
import { getGeotraxBaseUrl } from '../../../util/apiUtil';
import DataTableContent from '../../shared/DataTableContent';
import HaulersAddModal from './HaulersAddModal';
import styles from './HaulersView.module.scss';

export interface HaulersViewState {
  isOpen: boolean;
  isCloseRequest: boolean;
}

export interface HaulersViewProps {}

export class HaulersView extends Component<HaulersViewProps, HaulersViewState> {
  constructor(props: HaulersViewProps) {
    super(props);

    this.state = {
      isOpen: false,
      isCloseRequest: false,
    };
  }

  static getColumns = () => [
    {
      Header: addHeaderDataTest(null, 'sort-hauler-by-name', ADMIN_LABELS.HAULER_NAME),
      id: ADMIN_KEYS.NAME,
      accessor: ADMIN_KEYS.NAME,
      minWidth: 100,
      Cell: (props: { value: string }) => addDataTest(null, 'admin-hauler-name', props.value),
    },
    {
      Header: addHeaderDataTest(null, 'sort-hauler-by-externalId', ADMIN_LABELS.EXTERNAL_ID),
      id: ADMIN_KEYS.EXTERNAL_ID,
      accessor: ADMIN_KEYS.EXTERNAL_ID,
      minWidth: 50,
      style: {
        fontWeight: '900',
      },
      Cell: (props: { value: string }) => addDataTest(null, 'admin-hauler-externalId', props.value),
    },
    {
      Header: addHeaderDataTest(null, 'sort-hauler-by-address', ADMIN_LABELS.ADDRESS),
      id: ADMIN_KEYS.ADDRESS_LINE_ONE,
      accessor: getAddress,
      minWidth: 350,
      Cell: (props: { value: string }) => addDataTest(null, 'admin-hauler-address', props.value),
    },
  ];

  requestCloseModal = () => {
    this.setState({
      isOpen: true,
      isCloseRequest: true,
    });
  };

  closeModal = () => {
    this.setState({
      isOpen: false,
      isCloseRequest: false,
    });
  };

  openModal = () => {
    this.setState({
      isOpen: true,
      isCloseRequest: false,
    });
  };

  render() {
    const baseUrl = getGeotraxBaseUrl() + HAULERS_PATH;
    const columns = HaulersView.getColumns();

    const headerElement = <div className={styles.headerContainer} />;

    const props: any = {
      baseUrl,
      columns,
      header: HAULERS_TEXT,
      permissionKey: HAULERS_TEXT,
      renderTabs: headerElement,
      bypassCache: true,
      source: DATASOURCE.HAULER,
      enableExport: true,
      exportedFileName: 'haulers',
    };

    return (
      <div className={styles.container}>
        <DataTableContent {...props} />
        <HaulersAddModal
          isOpen={this.state.isOpen}
          openModal={this.openModal}
          closeModal={this.requestCloseModal}
          discardAcceptAction={this.closeModal}
          discardRejectAction={this.openModal}
          isCloseRequest={this.state.isCloseRequest}
        />
      </div>
    );
  }
}

export default connect(() => ({}))(HaulersView);
